import { render, staticRenderFns } from "./RightSideSalesComponent.vue?vue&type=template&id=39c6bf57&scoped=true&"
import script from "./RightSideSalesComponent.vue?vue&type=script&lang=js&"
export * from "./RightSideSalesComponent.vue?vue&type=script&lang=js&"
import style0 from "./RightSideSalesComponent.vue?vue&type=style&index=0&id=39c6bf57&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6bf57",
  null
  
)

export default component.exports